import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 2px 0 rgba(0, 255, 6, 0.4);
  }
  70% {
    box-shadow: 0 0 2px 12px rgba(0, 255, 6, 0);
  }
  100% {
    box-shadow: 0 0 2px 0 rgba(0, 255, 6, 0);
  }
`;

const StyledIcon = styled.div`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background: #00ff06;
  border-radius: 50%;
  animation: ${pulse} 1.5s linear infinite;
`;

const IconLive = props => (
  <StyledIcon
    size={props.size}
    onClick={props.onClick}
    style={props.style}
  />
);

IconLive.defaultProps = {
  size: 15,
  onClick: null,
  style: {},
};

IconLive.propTypes = {
  size: PropTypes.number,
  onClick: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.any),
};

export default IconLive;
